import { englishLocalisation, finnishLocalisation, norwegianLocalisation } from './translations';
export type { TextLocalisation } from './translations';

export enum Locale {
  EN = 'en-GB',
  NO = 'no-NO',
  FI = 'fi-FI',
}

export enum Brand {
  MobilePay = 'MobilePay',
  Vipps = 'Vipps',
}

export const CurrentTheme: Brand =
  new URLSearchParams(window.location.search).get('brand') === 'mp' ? Brand.MobilePay : Brand.Vipps;

const normalizedLocale = {
  en: Locale.EN,
  no: Locale.NO,
  fi: Locale.FI,
} as const;

const DEFAULT_LOCALE = Locale.EN;

const browserLocale = (navigator.languages?.[0] ?? navigator.language ?? DEFAULT_LOCALE)
  .toLowerCase()
  .split(/[-_]/)[0] as keyof typeof normalizedLocale;

export const CurrentLocale: Locale = normalizedLocale[browserLocale] ?? DEFAULT_LOCALE;

export const translationsMap = {
  [Locale.EN]: englishLocalisation,
  [Locale.NO]: norwegianLocalisation,
  [Locale.FI]: finnishLocalisation,
} as const;

export const currentTranslations = translationsMap[CurrentLocale];
